<template>
  <div>
    <div class="logo-bg" v-if="hasCreaAsta">
      <div class="view">
        <NotFound v-if="loading" text="Loading..."></NotFound>
        <div class="iscrivi-squadra" v-else-if="astaInfo">
          <v-card class="navy darken-1" width="300">
            <!-- @submit.stop.prevent="createAsta" -->
            <!-- lazy-validation -->
            <!-- we use vuelidate -->
            <v-card-title class="justify-center white--text">
              <div>
                <b>Iscrivi squadra a asta</b><br /><i>{{ astaInfo.name }}</i>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-4 px-8">
              <v-form ref="form" v-model="valid" v-if="!iscrizioneError">
                <v-row dense>
                  <v-col cols="3">
                    <div class="myPic" :class="myPicClass" @click="showDialog">
                      <label class="label">Logo</label>
                      <img v-if="myPic" :src="myPic" />
                    </div>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      label="Nome squadra"
                      v-model="myNomeSquadra"
                      name="myNomeSquadra"
                      persistent-hint
                      required
                      outlined
                      class="mb-4"
                      counter
                      maxlength="50"
                      :rules="[
                        rules.campoObbligatorio,
                        rules.nomeTroppoLungo(50),
                      ]"
                      dark
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-btn
                  rounded
                  depressed
                  large
                  id="iscrivi-squadra"
                  class="secondary white--text"
                  @click="iscriviSquadra"
                  :disabled="!valid"
                  >Iscriviti</v-btn
                >
              </v-form>
              <div v-else>
                <div class="white--text px-4 py-2">
                  {{ iscrizioneError }}
                </div>
                <div class="mt-4">
                  <v-btn
                    v-if="astaInfo.id"
                    @click="gotoAsta"
                    large
                    class="secondary white--text"
                  >
                    Vai all'Asta
                  </v-btn>
                </div>
                <div class="mt-4">
                  <v-btn
                    text
                    @click="gotoHome"
                    class="white-text text-decoration-underline"
                  >
                    Torna alla Home
                  </v-btn>
                </div>
              </div>
            </v-card-text>
          </v-card>
          <v-dialog eager v-model="dialog" max-width="700">
            <v-card class="navy darken-1">
              <v-card-title class="white--text">Scegli logo</v-card-title>
              <v-divider></v-divider>
              <div class="pics" :class="{ 'nice-scroll': !is_mobile }">
                <div
                  v-for="(pic, index) in defaultPics"
                  :key="index"
                  class="pic navy darken-2"
                  @click="saveMyPic(pic)"
                >
                  <img :src="pic" />
                </div>
              </div>
            </v-card>
          </v-dialog>
        </div>
        <NotFound
          v-else
          text="Asta non esistente o link di invito non valido"
        ></NotFound>
      </div>
    </div>
    <NotFound v-else></NotFound>
  </div>
</template>

<script>
import Config from "../../../config-app/config";
import db from "../../js/db";
import toast from "../../js/toast";
import NotFound from "./NotFound";
import Vuex from "vuex";
import mixins from "../../js/mixins";

export default {
  name: "iscrivi-squadra",
  mixins: [mixins, toast],
  components: { NotFound },
  data() {
    return {
      astaInfo: null,
      loading: true,
      iscrizioneError: "",
      dialog: false,
      hasCreaAsta: Config.CREA_ASTA,
      valid: false,
      myNomeSquadra: "",
      myPic: "",
      myPicClass: "",
      rules: {
        campoObbligatorio: (v) => !!v || "Campo obbligatorio",
        nomeTroppoLungo(nCharMax) {
          return (v) => (v || "").length <= nCharMax || "Nome troppo lungo";
        },
      },
    };
  },
  methods: {
    gotoHome() {
      this.$router.push("/");
    },
    gotoAsta() {
      this.$router.push({ name: "asta", params: { id: this.astaInfo.id } });
    },
    showDialog() {
      this.myPicClass = "";
      this.dialog = true;
    },
    saveMyPic(pic) {
      this.myPic = pic;
      this.dialog = false;
    },
    async iscriviSquadra() {
      if (!this.myPic) {
        this.errorToast("Errore", "Selezionare il logo");
        this.myPicClass = "mancante";
        return;
      }
      try {
        await this.runChecks();
        if (!this.iscrizioneError) {
          await db.createSquadra(
            this.astaInfo.id,
            this.user_uid,
            this.myNomeSquadra,
            this.myPic,
            this.astaInfo.lega.crediti
          );

          await db.addAstaToUser(
            Config.ANNO_ID,
            this.user_uid,
            Config.TORNEO_ID,
            this.astaInfo.id
          );

          this.successToast("Complimenti, ti sei iscritto all'asta", "");
          this.$router.push({ name: "asta", params: { id: this.astaInfo.id } });
        }
      } catch (error) {
        this.errorToast(
          "Errore mentre si tentava di iscriversi all'asta. Riprova.",
          error.message
        );
      }
    },
    async loadAsta() {
      const pass = this.$route.params.pass;
      if (pass) {
        try {
          const asta_id = await db.getAstaIdByPass(pass);
          this.astaInfo = await db.getAstaInfo(asta_id);
          await this.runChecks();
        } catch (error) {
          console.log(error.msg);
        }
      }
      this.loading = false;
    },

    async runChecks() {
      try {
        this.astaInfo = await db.getAstaInfo(this.astaInfo.id);
        const squadre = await db.getAstaSquadre(this.astaInfo.id);
        const curSquadre = Object.keys(squadre).length;
        const maxSquadre = this.astaInfo.lega.maxSquadre;
        if (curSquadre >= maxSquadre) {
          this.iscrizioneError = "Asta al completo";
          return;
        }
        if (squadre[this.user_uid]) {
          this.iscrizioneError = "Risulti già iscritto a questa asta";
          return;
        }
      } catch (error) {
        console.log(error.msg);
        return;
      }
    },
  },
  mounted() {
    console.log("IscriviSquadra mounted.");
    this.loadAsta();
  },
  destroyed() {
    console.log("CreaAsta destroyed.");
  },
};
</script>

<style lang="scss" scoped>
@import "../../main.scss";

.view {
  // height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  .iscrivi-squadra {
    // background-color: var(--v-primary-base);
    // background-image: repeating-linear-gradient(-14deg, #4db6ac, #009688 530px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;

    .ruoli {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
    }

    label,
    input,
    .v-messages__message,
    .v-input__icon {
      color: white !important;
    }

    #iscrivi-squadra.v-btn--disabled {
      background: rgb(255 255 255 / 33%) !important;
    }

    .myPic {
      border-radius: 4px;
      width: 56px;
      height: 56px;
      border: 1px solid hsla(0, 0%, 100%, 0.24);
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
      cursor: pointer;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      &.mancante {
        border: 2px solid var(--v-error-base);
        .label {
          color: var(--v-error-base) !important;
        }
      }
      &:not(.mancante):hover {
        border-color: white;
      }
      .label {
        position: absolute;
        color: rgba(255, 255, 255, 0.8) !important;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        font-size: 14px;
        line-height: 56px;
        cursor: pointer;
      }
      img {
        height: 95%;
        width: 95%;
        z-index: 1;
        position: relative;
        cursor: pointer;
        background: #2e434c;
        border-radius: 2px;
      }
    }
  }
}

.pics {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
  padding: 10px;
  overflow-y: auto;
  max-height: 450px;
  .pic {
    height: 100px;
    width: 100px;
    border-radius: 4px;
    overflow: hidden;
    &:hover {
      opacity: 0.8;
    }
    img {
      cursor: pointer;
      border-radius: 4px;
      height: 100%;
      width: 100%;
    }
  }
}
</style>
